/* globals Dali */
import CardCarousel from './card-carousel';

/**
 * Recently viewed cars card carousel functionality
 */
export default class RecentlyViewedCars {
  /**
   * Constructor of recently viewed cars
   * @param {Element} element - Element to bind on
   */
  constructor(element) {
    this._element = element;
    this._reventlyViewedCarsCarousel = this._element.querySelector('.recently-viewed-cars-carousel');

    this._recentlyViewedLicenses = localStorage.laakkonenViewedCars?.split(',').filter(Boolean) || [];
    this._currentLicense = this._element.querySelector('main')?.dataset?.license;
    this.#updateRecentlyViewedCars();

    this.#carDataQuery();
  }

  /**
   * Do car data query to Stage side
   * @private
   */
  async #carDataQuery() {
    const licenses = this._recentlyViewedLicenses.filter(license => license !== this._currentLicense).slice(0,6);

    if (licenses.length) {

      try {
        let [cars, carCard] = await Promise.all([this.#fetchCars(licenses), this.#fetchCarCard()]);
        this.#render(cars, carCard);
      } catch(error) {
        console.warn('Error loading car data', error);
      }
    }
  }

  /**
   * Fetch car card via Stage ajax interface
   * @async
   * @return {Promise} resolved after successful call
   */
  async #fetchCarCard() {
    const response = await fetch('/stage-ajax/car-card-template?cardtype=basicCard');
    return response.json();
  }

  /**
   * Send ajax request via fetch API to the Stage
   * @async
   * @param {string[]} licenses licenses to fetch
   * @return {Promise} resolved after successful call
   */
  async #fetchCars(licenses) {
    const response = await fetch('/stage-ajax/get-viewed-cars?licenses=' + licenses.toString() ,{
      method: 'GET'
    });
    return response.json();
  }

  /**
   * Update recently viewed cars' licenses in local storage
   */
  #updateRecentlyViewedCars() {
    // Set up to 7 licenses to local storage so the current one can be filtered out for rendering
    this._recentlyViewedLicenses = this._recentlyViewedLicenses.slice(0,7).filter(license => license !== this._currentLicense);
    this._recentlyViewedLicenses.unshift(this._currentLicense);
    localStorage.laakkonenViewedCars = this._recentlyViewedLicenses.join(',');
  }

  /**
   * Render recently viewed cars and initialize carousel
   * @param {object[]} carData car data object
  * @param {object} templateParts template parts
   */
  #render(carData, templateParts) {
    if (carData.length) {

      const {
        template: basicCardTemplate,
        partials: basicCardPartials,
        cardCustomClasses: basicCardCustomClasses
      } = templateParts;

      const data = {
        contentCardTitle: 'Viimeksi katsotut',
        transparent: true,
        nodivider: true,
        noline: true,
        cardCarouselClasses: 'recently-viewed-cars-card-carousel',
        carouselItems: carData,
        cardCustomClasses: basicCardCustomClasses
      };

      const template = document.getElementById('generic-content-card-template')?.innerHTML;
      const contentCardContent = document.getElementById('carousel-cards-template')?.innerHTML;
      const analytics = document.getElementById('analytics-template')?.innerHTML;

      const partials = {
        contentCardContent,
        singleCarouselItem: basicCardTemplate,
        analytics,
        ...basicCardPartials
      };

      if (template) {
        const html = window.Dali.render(template, data, partials);
        this._reventlyViewedCarsCarousel.innerHTML = html;

        // Initialize card carousel
        CardCarousel.customInit(this._element.querySelector('.recently-viewed-cars-card-carousel'));
      }
    }
  }

  /**
   * Static init function for recently viewed cars
   *
   * @static
   */
  static init() {
    const carPageElement = document.querySelector('body.car');
    if (carPageElement) { new RecentlyViewedCars(carPageElement); }
  }
}
